import { useMemo } from 'react'

import { FilterOption } from '../types'

interface UsePermanentlyDisqualifiedFilterProps {
  selectedPermanentlyDisqualified: string[]
  onPermanentlyDisqualifiedChange: (values: string[]) => void
}

export const usePermanentlyDisqualifiedFilter = ({
  selectedPermanentlyDisqualified,
  onPermanentlyDisqualifiedChange,
}: UsePermanentlyDisqualifiedFilterProps) => {
  const baseOptions = useMemo<FilterOption[]>(() => {
    return [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ]
  }, [])

  // Update options to reflect selected state
  const options = useMemo<FilterOption[]>(() => {
    return baseOptions.map((option) => ({
      ...option,
      selected: selectedPermanentlyDisqualified.includes(option.value),
    }))
  }, [baseOptions, selectedPermanentlyDisqualified])

  return {
    options,
    selected: selectedPermanentlyDisqualified,
    onChange: onPermanentlyDisqualifiedChange,
    isLoaded: true,
  }
}
